import ThankyouContainer from "./containers/ThankyouContainer";

import "./styles.scss";
export default ThankyouContainer;
